import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/bancos/1touchpay`;

export const useLedgerAudit = () => {
  const [audit, setAudit] = useState(null);
  const [cuadre, setCuadre] = useState(null);
  const [checkedAt, setCheckedAt] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const controller = useRef(null);
  const active = useRef(true);
  const refresh = useCallback(async () => {
    controller.current?.abort();
    const abort = new AbortController();
    controller.current = abort;
    setLoading(true);
    const read = async (name, path, setter) => {
      try {
        const { data } = await axios.get(`${API}/${path}`, {
          signal: abort.signal, timeout: 20000, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (data.error) throw new Error('Lectura fallida');
        if (!active.current || abort.signal.aborted) return;
        setter(data);
        setErrors(previous => ({ ...previous, [name]: false }));
        if (name === 'audit') setCheckedAt(new Date().toISOString());
      } catch (e) {
        if (active.current && !abort.signal.aborted) setErrors(previous => ({ ...previous, [name]: true }));
      }
    };
    // Cada panel publica por separado; nada de esto bloquea la tabla.
    await Promise.all([read('audit', 'ledger/audit', setAudit), read('cuadre', 'cuadre', setCuadre)]);
    if (active.current && controller.current === abort) setLoading(false);
  }, []);
  useEffect(() => {
    active.current = true;
    refresh();
    const timer = setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 60000);
    return () => { active.current = false; controller.current?.abort(); clearInterval(timer); };
  }, [refresh]);
  return { audit, cuadre, checkedAt, loading, error: Object.values(errors).some(Boolean), refresh };
};